import http from "app/services/httpService";
import config from "config.json";
const { apiUrl } = config;

//Post data to api
const addApiPartnerService = async (values) => {
  try {
    const url = `${apiUrl}/apipartner/add`;
    const { data } = await http.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};
//Get data for list
const getApiPartner = async (queryString) => {
  try {
    const url = `${apiUrl}/apipartner/all${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

// get data for edit
const getApiPartnerById = async (id) => {
  try {
    const url = `${apiUrl}/apipartner/member/${id}`;
    const data = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

// update
const updateApiPartnerService = async (memId, values) => {
  try {
    const url = `${apiUrl}/apipartner/update/member/${memId}`;
    const { data } = await http.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};
const getServiceTagged = async (id) => {
  try {
    const url = `${apiUrl}/servicemaster/apiuser-servicemapping/${id}`;
    const data = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const updateService = async (value) => {
  try {
    const url = `${apiUrl}/servicemaster/tag-service`;
    const { data } = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

//export
const exportList = async (queryString) => {
  try {
    const url = `${apiUrl}/apipartner/member/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const getTransactionByApiUser = async (queryString) => {
  try {
    const url = `${apiUrl}/apipartner/transaction-history-all${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const exportLedgerByApiUser = async (queryString) => {
  try {
    const url = `${apiUrl}/apiusergroups/transaction-history-all/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

//#endregion

// add S2s service
const postS2sSerive = async (value) => {
  try {
    const url = `${apiUrl}/apipartner/tag-s2sSetting`;
    const data = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

// get s2s service by id

const getServiceDataById = async (id) => {
  try {
    const url = `${apiUrl}/apipartner/s2s/${id ? `${id}` : ""}`;
    const { data } = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

export {
  addApiPartnerService,
  getApiPartner,
  getApiPartnerById,
  updateApiPartnerService,
  getServiceTagged,
  updateService,
  exportList,
  getTransactionByApiUser,
  exportLedgerByApiUser,
  postS2sSerive,
  getServiceDataById,
};
